import styles from 'styles/views/App.css';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MODE } from 'constants/mode';
import { nearestElement } from 'utils/dom';
import { beautifyPageviewOperators } from 'utils/operatorPurge';
import { find, findIndex } from '../utils/array';
import Event, {SELECTION_TYPE} from 'model/Event';
import contextService from 'services/contextService';
import { editorStateActions } from 'redux/modules/editorState';
import * as actionsPageview from 'redux/modules/pageview/pageviewActions';
import AppPanel from 'views/AppPanel';
import ElementPicker from 'views/ElementPicker';
import Highlighter from 'views/Highlighter';
import EventEditor from 'views/EventEditor';
import Notifier from './widgets/Notifier';
import Confirm from './widgets/Confirm';
import { MESSAGE } from '../constants/message';

export const PAGE_TYPE = {
  ALL: 'all',
  SINGLE: 'single'
};

export const SELECTOR_MODE = {
  SINGLE: 'single',
  SIMILAR: 'similar',
  MANUAL: 'manual'
};

export class App extends Component {
  static propTypes = {
    editorState: PropTypes.object,
    editorStateActions: PropTypes.object,
    notification: PropTypes.object,
    onExit: PropTypes.func,
    pageviewActions: PropTypes.object,
    pageviewEvents: PropTypes.array,
    siteId: PropTypes.string.isRequired,
    storage: PropTypes.object.isRequired
  };

  state = {
    elementHovered: null,
    eventBeingEdited: null,
    limitTo: null,
    eventContent: false,
    eventHighlighted: null,
    eventToBeDeleted: false,
    pageview: {},
    pageviewId: null,
    mobileVersion: false,
    appPanelHide: false
  }

  componentWillMount () {
    // let mode = '';
    // if (this.props.storage.get && typeof this.props.storage.get === 'function') {
    //   mode = this.props.storage.get('_aurycMode') || MODE.EDIT;
    // } else {
    //   mode = this.props.storage.getByKey('_aurycMode') || MODE.EDIT;
    // }

    const auryc = (JSON.parse(localStorage.auryc || '{}'));
    const mode = auryc._aurycMode || MODE.EDIT;
    let path ='mode';
    let operation = 'update';
    this.props.editorStateActions.dynamicDispatch(
      Object.assign({params: mode}, {path, operation})
    );
  }

  componentDidMount () {
    this.props.editorStateActions.getEvents(this.props.siteId);
    this.props.pageviewActions.getPageviewEvents(this.props.siteId);
    let predefineLocation = contextService.get('position');
    let siteId = contextService.get('siteId');
    if (siteId === '933-lei-test' || '1006-wildalaskancompanycom') {
      let overriderStyle = document.createElement('style');
      overriderStyle.textContent = `
      .exit-modal.fade.show {
        z-index: 2147483644 !important;
      }
      `;
      document.head.append(overriderStyle);
    }
    if (predefineLocation && predefineLocation.hasOwnProperty('x') && predefineLocation.hasOwnProperty('y')) {
      let selectEle = document.elementsFromPoint(
        parseInt(predefineLocation.x, 10), parseInt(predefineLocation.y, 10))[0];
      this.selectElement(selectEle);
    }
    let deviceType = contextService.get('deviceType');
    if (['Tablet', 'Smartphone'].includes(deviceType) || /Mobi/i.test(window.navigator.userAgent)) {
      this.setState({mobileVersion: true});
    } else {
      this.setState({mobileVersion: false});
    }
    window.addEventListener('message', this.editorPostMessageHandler);
  };

  editorPostMessageHandler = event => {
    let evtData = event.data;
    if (evtData.source === '_ar_' && evtData.command === MESSAGE.TOGGLE_MOBILE_EVENT_MARKER) {
      this.setState({mobileVersion: true});
      contextService.set('deviceType', evtData.deviceType);
    } else if (evtData.source === '_ar_' && evtData.command === MESSAGE.EXIT_MOBILE_EVENT_MARKER) {
      this.setState({mobileVersion: false});
      contextService.set('deviceType', evtData.deviceType);
    } else if (evtData.source === '_ar_' && evtData.command === MESSAGE.CLOSE_EDITOR) {
      this.cancelEdit();
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.editorState.showEventList &&
      nextProps.editorState.showEventList !== this.props.editorState.showEventList) {
      this.setState({...this.state, elementHovered: null, eventBeingEdited: null});
    } else if (nextProps.editorState.events.length) {
      let eventId = '';
      let event;
      try {
        eventId = localStorage.getItem('_cachedEvent');
        if (eventId.length) {
          event = nextProps.editorState.events.find(item => item.attrs.id === eventId);
          if (event && event.attrs.eventType !== 'PAGEVIEW') {
            this.setState({...this.state,
              elementHovered: null, eventBeingEdited: event});
            localStorage.setItem('_cachedEvent', '');
          } else {
            this.setState({ ...this.state, elementHovered: null, eventBeingEdited: null, pageviewId: eventId });
          }
        }
      } catch (e) {
        // nothing happen
      }
    }
  };

  componentWillUpdate (nextProps, nextState) {
    const { eventBeingEdited }= this.state;
    if ((eventBeingEdited && nextState.eventBeingEdited && eventBeingEdited.id !== nextState.eventBeingEdited.id) ||
    (eventBeingEdited === null && nextState.eventBeingEdited !== null)) {
      this.setState({
        pageview: {},
        eventContent: this.hasEventContent(nextState.eventBeingEdited)
      });
    }
  }

  toggleAppPanelHide = () => {
    this.setState({appPanelHide: !this.state.appPanelHide}, () => {
      // if (this.state.appPanelHide) {
      //   document.body.style.cssText +=
      //     '; padding-top: 0px !important; transition: margin 300ms cubic-bezier(0, 0, 0, 0.97);';
      // } else {
      //   document.body.style.cssText +=
      //     '; padding-top: 50px !important; transition: margin 300ms cubic-bezier(0, 0, 0, 0.97);';
      // }
    });
  };

  render () {
    let trackingEnabled = this.props.editorState.mode === MODE.EDIT &&
                          (!this.state.eventBeingEdited || !this.state.eventBeingEdited.customized);
    let focusedEvent = this.state.eventBeingEdited ? this.state.eventBeingEdited : this.state.eventHighlighted;
    let isNewEvent = this.isNewEvent(focusedEvent);
    const { pageviewId, appPanelHide } = this.state;
    const { notification } = this.props;
    return (
      <div className={styles.container}>
        <AppPanel
          editorState={this.props.editorState}
          editorStateActions={this.props.editorStateActions}
          events={this.props.editorState.events}
          onEditEvent={this.editEvent}
          pageviewEvents={this.props.pageviewEvents}
          onHighlightEvent={this.highlightEvent}
          onDeleteEvent={this.deleteEvent}
          onExit={this.props.onExit}
          pageviewId={pageviewId}
          appPanelHide={appPanelHide}
          toggleAppPanelHide={this.toggleAppPanelHide}
          removePageviewId={this.removePageviewId}
          projectId={this.props.siteId}/>
        <ElementPicker
          enabled={trackingEnabled}
          editorState={this.props.editorState}
          onHover={this.hoverElement}
          onSelect={this.selectElement}/>
        <Highlighter
          editorState={this.props.editorState}
          events={this.props.editorState.events}
          focusedEvent={focusedEvent}
          hoveredElement={this.state.elementHovered}
          />
        <EventEditor
          mobileVersion={this.state.mobileVersion}
          // mobileVersion
          originEditedEvent={this.state.originEditedEvent}
          event={this.state.eventBeingEdited}
          computedEl={this.state.computedEl}
          isNewEvent={isNewEvent}
          eventContent={this.state.eventContent}
          onChangeLimit={this.handleLimitRadio}
          onChangeTextContent={this.handleTextContent}
          onCancel={this.cancelEdit}
          onChangeName={this.changeName}
          onChangeLimitText={this.changeLimitText}
          onChangeSelector={this.changeSelector}
          onPageScopeChange={this.changePageScope}
          onSave={this.saveEvent}
          onResetSelector={this.resetSelector}
          onUpdatePageview={this.updatePageviewState}
          onDeleteEvent={this.deleteEvent}
          onSelectionTypeChange={this.changeSelectionType}
          editorState={this.props.editorState}
          editorStateActions={this.props.editorStateActions}/>
        {
          notification.visible &&
            <Notifier
              success={notification.success}
              message={notification.message}/>
        }
        {
          this.state.eventToBeDeleted &&
            <Confirm
              cancelLabel='Cancel'
              confirmLabel='Delete Event'
              onClick={this.handleDeleteConfirmation}
              title='Delete Event?'>
              <p>
                You are about to delete this event. <br/>
                Are you sure you want to delete?
              </p>
            </Confirm>
        }
      </div>
    );
  };

  cancelEdit = () => {
    this.setState({eventBeingEdited: null, originEditedEvent: null});
  };

  changeName = (e) => {
    let name = e.target.value;
    let event = this.state.eventBeingEdited.deepCopy;
    event.name = name;
    this.setState({...this.state, eventBeingEdited: event});
  };

  changeLimitText = (e) => {
    let limitTo = e.target.value;
    this.setState({...this.state, limitTo: limitTo});
  };

  changePageScope = (pageScope) => {
    let event = this.state.eventBeingEdited.deepCopy;
    event.restrictToUrl = (pageScope !== PAGE_TYPE.ALL);
    if (pageScope === PAGE_TYPE.SINGLE) {
      const {pageview} = this.state;
      if (pageview && pageview.input) {
        const content = beautifyPageviewOperators(pageview.input, pageview.operator);
        event.attrs.pathCondition = content;
      }
    } else {
      delete event.attrs.pathCondition;
    }
    this.setState({...this.state, eventBeingEdited: event});
  };

  changeSelectionType = (selectionType) => {
    let event = this.state.eventBeingEdited.deepCopy;
    event.selectionType = selectionType;
    this.syncEventProperties(event, ['selectionType']);
  };

  changeSelector = (cssSelector) => {
    let event = this.state.eventBeingEdited.deepCopy;
    let originalEditedEvent = this.state.originEditedEvent.deepCopy;
    event.setCustomCssSelector(cssSelector);
    originalEditedEvent.attrs.content = cssSelector;
    console.log(originalEditedEvent);
    // this.setState({originEditedEvent: originalEditedEvent});
    this.syncEventProperties(event, ['cssSelector'], originalEditedEvent);
  };

  editEvent = (event) => {
    if (event.attrs.eventType === 'PAGEVIEW') {
      this.setState({ ...this.state, eventBeingEdited: null, pageviewId: event.attrs.id });
    } else {
      this.setState({...this.state, eventBeingEdited: event});
    }
  };

  enterEditorMode = () => {
    this.setState({...this.state, mode: MODE.EDIT});
  };

  enterBrowseMode = () => {
    this.setState({...this.state, mode: MODE.BROWSE, eventBeingEdited: null});
  };

  getEvent (el) {
    // find an event that contains the element
    let event = find(this.props.editorState.events, (event) => {
      if (event.elements && event.elements.includes(el)) {
        return true;
      }
    });
    return event;
  };

  resetSelector = () => {
    let event = this.state.eventBeingEdited.deepCopy;
    event.removeCustomCssSelector();
    this.syncEventProperties(event, ['cssSelector']);
  };

  updatePageviewState = (input, operator) => {
    this.setState({
      pageview: {
        input,
        operator
      }
    });
  };

  getEventIndexById (id) {
    return findIndex(this.props.editorState.events, (event) => {
      if (event.id === id) {
        return true;
      }
    });
  };

  handleLimitRadio = (e) => {
    const newEventContent = !this.state.eventContent;
    this.setState({
      eventContent: newEventContent
    });
  };

  handleTextContent = (e) => {
    const val = e.target.value;
    let event = this.state.eventBeingEdited.deepCopy;
    event.attrs.tempEventContent = val;
    this.setState({...this.state, eventBeingEdited: event});
  };

  highlightEvent = (event) => {
    this.setState({...this.state, eventHighlighted: event});
  };

  hoverElement = (el) => {
    if (el !== this.state.elementHovered) {
      let event = null;
      if (el) {
        if (!this.state.eventBeingEdited || !this.isNewEvent(this.state.eventBeingEdited) ||
          (this.state.eventBeingEdited && this.state.eventBeingEdited.selectionType === SELECTION_TYPE.SINGLE)) {
          const computedEl = nearestElement(el);
          event = this.getEvent(computedEl);
        }
      }
      // when event list popup is opened, only highlight elements of defined event
      if (this.props.editorState.showEventList && !event) {
        el = null;
      }
      this.setState({...this.state, elementHovered: el, eventHighlighted: event});
    }
  };

  saveEvent = () => {
    const { pageview, eventContent } = this.state;
    let index = this.getEventIndexById(this.state.eventBeingEdited.id);
    let events = this.props.editorState.events.slice();
    let event = this.state.eventBeingEdited;
    // TODO: need to delete path condition when editing the event and changing page type
    const restrict = event.restrictToUrl ? PAGE_TYPE.SINGLE : PAGE_TYPE.ALL;
    if (restrict === PAGE_TYPE.SINGLE) {
      if (pageview && pageview.input && pageview.operator) {
        const content = beautifyPageviewOperators(pageview.input, pageview.operator);
        event.attrs.pathCondition = content;
      }
    } else {
      event.attrs.pathCondition = null;
    }
    if (![SELECTION_TYPE.SINGLE, SELECTION_TYPE.SIMILAR].includes(event.selectionType) || !eventContent) {
      delete event.attrs.eventContent;
      delete event.attrs.tempEventContent;
    } else {
      if (event.attrs.tempEventContent) {
        event.attrs.eventContent = event.attrs.tempEventContent;
      }
      delete event.attrs.tempEventContent;
    }
    if (index < 0) {
      this.props.editorStateActions.createEvent(event);
    } else {
      this.props.editorStateActions.updateEvent(event);
    }
    this.setState({...this.state, events, eventBeingEdited: null});
  };

  removePageviewId = () => {
    localStorage.setItem('_cachedEvent', '');
    this.setState({
      pageviewId: null
    });
  };

  handleDeleteConfirmation = (confirmed) => {
    let { eventToBeDeleted } = this.state;
    this.setState({
      eventToBeDeleted: null
    });
    if (confirmed && eventToBeDeleted) {
      this.props.editorStateActions.deleteEvent(eventToBeDeleted);
      this.cancelEdit();
    }
  };

  deleteEvent = (event) => () => {
    this.setState({
      eventToBeDeleted: event
    });
  };

  hasEventContent = (event) => {
    return (event && event.attrs)? (event.attrs.eventContent &&
      !!event.attrs.eventContent.length) : false;
  }

  selectElement = (el, shadowRoot) => {
    // cannot define a new event when event list is open.
    if (this.props.editorState.showEventList) {
      return;
    }

    const computedEl = nearestElement(el);
    if (!computedEl) {
      return;
    }

    let url;
    if (this.props.editorState.events && this.props.editorState.events.length > 0) {
      if (!computedEl.currentContextPath || computedEl.currentContextPath.length === 0) {
        url = this.props.editorState.events[0].currentContextPath;
      }
    }
    // cannot highlight or move to another element by mouse if the event is customized
    if (this.state.eventBeingEdited && this.state.eventBeingEdited.customized) {
      return;
    }

    if (this.state.eventBeingEdited && this.isNewEvent(this.state.eventBeingEdited)) {
      if (this.state.eventBeingEdited.selectionType === SELECTION_TYPE.SINGLE) {
        let event = this.state.eventHighlighted;
        let eventBeingEdited = null;
        if (event) {
          eventBeingEdited = event.deepCopy;
        } else {
          eventBeingEdited = new Event(computedEl, this.props.siteId, url);
        }
        this.setState({...this.state,
          eventContent: this.hasEventContent(eventBeingEdited),
          eventBeingEdited, eventHighlighted: null});
      } else if (this.state.eventBeingEdited.selectionType === SELECTION_TYPE.MANUAL) {
        let eventBeingEdited = this.state.eventBeingEdited.deepCopy;
        eventBeingEdited.toggleElement(computedEl);
        this.setState({...this.state,
          eventContent: this.hasEventContent(eventBeingEdited),
          eventBeingEdited});
        // TODO update element count
      }
    } else {
      let event = this.state.eventHighlighted;
      let eventBeingEdited = null;
      if (event) {
        eventBeingEdited = event.deepCopy;
        // set temp event content
        eventBeingEdited.attrs.tempEventContent = event.getTextContent(computedEl);
      } else {
        eventBeingEdited = new Event(computedEl, this.props.siteId, url, shadowRoot);
      }
      this.setState({...this.state,
        computedEl,
        eventContent: this.hasEventContent(eventBeingEdited),
        originEditedEvent: eventBeingEdited,
        eventBeingEdited,
        eventHighlighted: null});
    }
  };

  isNewEvent (focusedEvent) {
    let isNew = !focusedEvent || findIndex(this.props.editorState.events, (event) => {
      return event.id === focusedEvent.id;
    }) < 0;
    return isNew;
  }

  syncEventProperties = (event, propertyNames, originalEditedEvent) => {
    if (!event) {
      return;
    }

    propertyNames.forEach((key) => {
      let operation = 'update';
      this.props.editorStateActions.dynamicDispatch(
        Object.assign({params: event[key]}, {path: key, operation})
      );
    });
    if (propertyNames.includes('cssSelector')) {
      this.setState({
        ...this.state,
        eventBeingEdited: event,
        originEditedEvent: originalEditedEvent
      });
    } else {
      this.setState({...this.state, eventBeingEdited: event});
    }
  };
}

const getEventArray = (byIds, ids) => {
  return ids.map(id => byIds[id]);
};

const mapStateToProps = (state) => ({
  editorState: state.editorState,
  notification: state.notification,
  pageviewEvents: getEventArray(state.pageview.byIds, state.pageview.ids),
  storage: contextService.get('storage')
});

const mapDispatchToProps = (dispatch) => ({
  editorStateActions: bindActionCreators(editorStateActions, dispatch),
  pageviewActions: bindActionCreators(actionsPageview, dispatch),
  storage: contextService.get('storage')
});

const ConnectApp = connect(mapStateToProps, mapDispatchToProps)(App);

export default ConnectApp;



/** WEBPACK FOOTER **
 ** ./src/views/App.js
 **/